<template>
  <div class="client-card border"
       v-if="vehicle"
       :class="[vehicle.beingVerify ? 'pulse' : '']"
       @click="setSelectedVehicle(key)"
  >
    <div class="client-card__panel">
      <i class="ki-duotone ki-car-2 fs-3x" :class="[vehicle.verify ? 'text-primary' : 'text-warning', vehicle.beingVerify ? 'opacity-0' : '']">
        <span class="path1"></span>
        <span class="path2"></span>
        <span class="path3"></span>
        <span class="path4"></span>
        <span class="path5"></span>
        <span class="path6"></span>
      </i>
      <i v-if="vehicle.beingVerify" class="ki-duotone ki-abstract-33 fs-3x text-primary verified opacity-50">
        <span class="path1"></span>
        <span class="path2"></span>
      </i>
      <div class="ms-4">
        <div class="fs-6 fw-bolder text-gray-700">{{ vehicle.number ?? vehicle.vin }}</div>
        <template v-if="!(vehicle.podft && !vehicle.podft.success)">
          <div v-if="vehicle.beingVerify" class="fs-8 text-primary opacity-75">Проверка документов</div>
          <div v-else class="fs-8 text-gray-400">
            {{ (vehicle.color ?? '') +' '+ (vehicle.mark ?? '')+' '+ (vehicle.model ?? '') +' '+ (vehicle.year ?? '')  }},
            <span class="text-danger opacity-75">{{ vehicle.verify ? 'Резидент' : 'Нерезидент' }}</span>
          </div>
        </template>
        <template v-else>
          <div class="fs-8 text-danger opacity-75">{{ vehicle.podft.message}}</div>
        </template>
      </div>
      <div class="card_change" v-if="!changeDisabled">
        <slot name="change"></slot>
      </div>
    </div>
    <slot name="footer" v-if="!changeDisabled"></slot>
  </div>
</template>

<script>
export default {
  name: 'VehicleCard',
  props: {
    vehicle: {
      type: Object,
      default: null
    },
    key: {
      type: Number,
      default: 0
    },
    selectedClient: 0,
    isDeleted: {
      type: Boolean,
      default: false
    },
    changeDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['setSelectedVehicle', 'deleteVehicle'],
  methods: {
    setSelectedVehicle(key) {
      this.$emit('setSelectedVehicle', key)
    },
    deleted(key) {
      this.$emit('deleteVehicle', key)
    }
  }
}
</script>

<style></style>